import { useOutletContext } from "react-router-dom";
import type { EventContent } from "@tih/shared";
import { EventDetails } from "../components/EventDetails";
import { Program } from "../components/Program";
import { Venue } from "../components/Venue";

export function EventPage() {
  const content = useOutletContext<EventContent | null>();
  return (
    <>
      <EventDetails cards={content?.cards} />
      <Program items={content?.program} />
      <Venue details={content?.venueDl} />
    </>
  );
}
